import React from "react";
import "./experience.css";

export default function ExperienceCard(props) {
  return (
    <div className="timeline-item">
      <div className="timeline-marker" />
      <div className="timeline-card">
        <div className="timeline-card-head">
          <div>
            <a
              href={props.link}
              target="_blank"
              rel="noreferrer"
              className="timeline-company"
            >
              {props.componyName}
            </a>
            <p className="timeline-role">{props.designation}</p>
          </div>
          <span className="timeline-time">{props.time}</span>
        </div>
        <ul className="timeline-points">
          {props.desc["description"].map((data, id) => (
            <li key={id}>{data}</li>
          ))}
        </ul>
      </div>
    </div>
  );
}
